module.exports = __webpack_public_path__ + "static/img/6-国信证券.6b671d30.png";